module.exports = __webpack_public_path__ + "img/1.ceb9f2be.jpg";